<div class="app-modal">
  <div mat-dialog-title class="draw-compliance-header">Confirmation required!</div>
  @if (data && data.note) {
    <div mat-dialog-content>
      <p>{{ data.note }}</p>
    </div>
  }
  <div mat-dialog-actions class="action-buttons">
    <button data-id="cancelButton" mat-raised-button [color]="'warn'" (click)="no()">Cancel</button>
    <button data-id="confirmButton" mat-raised-button [color]="'primary'" (click)="yes()">Confirm</button>
  </div>
</div>
